import { Link } from 'react-router-dom'

// For links whose destination may be an internal route or an absolute URL
// depending on which host is serving the build (see lib/siteLinks.js):
// react-router <Link> for routes, plain <a> for absolute URLs.
export default function SiteLink({ to, children, ...props }) {
  if (/^https?:/.test(to)) {
    return (
      <a href={to} {...props}>
        {children}
      </a>
    )
  }
  return (
    <Link to={to} {...props}>
      {children}
    </Link>
  )
}
